import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '../assets/css/styles.css';
import logo from '../assets/img/logo.png';
import separador from '../assets/img/separador.png';
import Dialog from '../components/dialog.jsx';
import Progress from '../components/progress.jsx';
import { typeWriter } from '../funciones/typeWriter.js';
import { validarCorreo, validaContraseña, sendMail, Propio } from '../funciones/generales.js'
import { getApi, Recupera } from '../funciones/sesion.js'
import { Recuperacion } from '../funciones/mensajes.js'
function sombrero(mensaje, velocidad, fun) {
    createRoot(document.getElementById("dg")).render(<Dialog />)
    setTimeout(() => {
        const elemento = document.getElementById('mensaje');
        typeWriter(elemento, mensaje, velocidad, function () {
            createRoot(document.getElementById("dg")).unmount(<Dialog />)
            if (fun == "1") {
                window.location.replace('/#/Sesion');
            }
        })
    }, 300);
}

function RecuperaC(props) {
    const [random, setRandom] = useState("");
    const [codigo, setCodigo] = useState("");
    const [email, setEmail] = useState("");
    const [contrasena, setContrasena] = useState("");
    const [vcontrasena, setvContrasena] = useState("");

    function $recupera() {
        createRoot(document.getElementById("dg")).render(<Progress />)
        Recupera(email, contrasena).then(data => {
            createRoot(document.getElementById("dg")).unmount(<Progress />)
            sombrero("¡Tu santo y seña ya fue actualizado, te enviaré de nuevo al inicio de sesión, hasta la proxima!", 100, "1");

        });

    }
    function Recover() {
        getApi("escoba_getEmail/" + email).then(data => {
            if (!validarCorreo(email)) {
                sombrero("¡Me parece que hay algo mal con la estructura de tu email, revisa que todo este bien!", 100);
                return;
            }
            if (random == "") {
                let rdm = Math.floor(100000 + Math.random() * 900000)
                setRandom(rdm);
                /*new SendMailAsynTask(env.mail()[0], env.mail()[1]).execute(
                    new SendMailAsynTask.Mail(env.mail()[0], Receptor, "CÓDIGO DE VERIFICACIÓN", Dialogos.Aceptacion(Apellido, Codigo))
 
                );*/
                sombrero("¡Me parece que ha llegado tu carta a tu email, dentro encontraras tu código de verificación!", 100, "");
                sendMail(email, "CÓDIGO DE VERIFICACIÓN", Recuperacion(rdm));
                document.getElementById("codigo").disabled = false;
                return;
            }
            if (random != codigo) {
                sombrero("¡Me parece que el código de verificación es incorrecto, intenta nuevamente!", 100, "0");
                return;
            }
            if (!validaContraseña(contrasena, "", "1")) {
                sombrero("¡Me parece que tu contraseña tiene menos de 10 carácteres, intenta nuevamente!", 100);
                return;
            }

            if (!validaContraseña(contrasena, vcontrasena, "2")) {
                sombrero("¡Me parece que tus contraseñas no coinciden, intenta nuevamente!", 100);
                return;
            }
            $recupera();
        });
    }

    useEffect(() => {
        //createRoot(document.getElementById("dg")).render(<Dialog />)
    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>
            <div id="dg">

            </div>

            <div class="container center-v">
                <div class="login">
                    <div>
                        <div class="logo center-v-">
                            <img src={logo} class="img-responsive ic-logo-xs" />
                        </div>
                        <p class="titulo-copa">Recuperar santo y seña</p>
                        <div class="separador">
                            <img src={separador} class="img-responsive"></img>
                        </div>
                    </div>

                    <div>
                        <input type='text' class="form-control" placeholder="Email" maxLength={150} onChange={(e) => setEmail(e.target.value)}></input>
                        <input id="codigo" disabled type='text' class="form-control" 
                        maxLength={6} placeholder="Código de verificación" 
                         
  inputMode="numeric"
  pattern="[0-9]*"
  value={codigo}
  onChange={(e) => setCodigo(e.target.value.replace(/[^0-9]/g, ''))}
                        /*</div>onChange={(e) => setCodigo(e.target.value)}*/></input>
                        <input type='password' class="form-control" placeholder="Contraseña" onChange={(e) => setContrasena(e.target.value)}></input>
                        <input type='password' class="form-control" placeholder="Confirmar contraseña" onChange={(e) => setvContrasena(e.target.value)}></input>
                    </div>
                    <div class="separador">
                        <img src={separador} class="img-responsive"></img>
                    </div>

                    <div>
                        <button class="form-control" onClick={Recover}>REVELIO</button>
                    </div>


                </div>
            </div>

        </div>);
}

export default RecuperaC;